import React, {
	lazy,
	Suspense,
	useLayoutEffect,
	useEffect,
	useState,
} from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/css/main.css';
import Gallery from './View/Gallery/Gallery';
import Nftmarket from './View/NftMarket/NftMarket';
import Story from './View/Story/Story';
import NftmarketDetail from './View/NftMarket/NftMarketDetail';
import Mypage from './View/Mypage/Mypage';
import NewMain from './View/Main/NewMain';
import ScrollToTop from './scrollToTop';
import { post_Email_Login, _inputActionLog } from './function/functions';
import Loading from './component/Loading';
import Main from './View/Main/Main';
import M_newMain from './View/Main/M_newMain';
import { isMobile } from 'react-device-detect';
import {
	useAccount,
	useConnect,
	useDisconnect,
	useNetwork,
	useSigner,
} from 'wagmi';
import { connectors, web3AuthInstance, web3AuthModal } from '.';
import { OAuthData } from './recoil-states/user-state/user-OAuth';
import { translatedText } from './recoil-states/language-state';
import MetamaskLogin from './component/MetamaskLogin';

function App() {
	const { connectAsync } = useConnect();
	const { isConnected, isDisconnected, address } = useAccount();
	const { chain, chains } = useNetwork();
	const { data: signer } = useSigner();

	const [userData, setUserData] = useRecoilState(OAuthData);
	const textData = useRecoilValue(translatedText);

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const [openVideo, setOpenVideo] = useState(false);
	const [loading, setLoading] = useState(false);
	const loginConnector = sessionStorage.getItem('login.connector');

	const getOpenLoginCache = () => {
		const openLoginCache = sessionStorage.getItem('openlogin_store');
		if (openLoginCache) {
			const parsedOpenLoginCache = JSON.parse(
				sessionStorage.getItem('openlogin_store')
			);
			return parsedOpenLoginCache;
		} else return null;
	};

	const handleAuth = async () => {
		if (loginConnector === 'cryptoWallet') return;
		setLoading(true);
		try {
			await connectAsync({
				connector: connectors[0],
			});
			const address = await connectors[0].getAccount();
			const parsedOpenLoginCache = getOpenLoginCache();
			if (parsedOpenLoginCache) {
				const _post_Email_Login = await post_Email_Login(
					parsedOpenLoginCache.email,
					parsedOpenLoginCache.typeOfLogin,
					address
				);
				setUserData({ ..._post_Email_Login });
			}
			sessionStorage.setItem('login.connector', 'web3auth');
			setLoading(false);
		} catch (error) {
			if (error.message !== 'User rejected request') {
				alert(textData.alert.loginError);
			}
			setLoading(false);
		}
	};
	const handleMatamaskAuth = async () => {
		if (loginConnector === 'web3auth') return;
		setLoading(true);
		try {
			let Login;
			let address;
			if (isMobile) {
				Login = await connectAsync({
					connector: connectors[2],
				});
				address = (await connectors[2].getAccount()) || Login?.account;
			} else {
				Login = await connectAsync({
					connector: connectors[1],
				});
				address = (await connectors[1].getAccount()) || Login?.account;
			}
			if (Login?.account?.length > 0 && address?.length > 0) {
				const _post_Email_Login = await post_Email_Login(
					'',
					'local',
					address?.toLocaleLowerCase()
				);
				sessionStorage.setItem('login.connector', 'cryptoWallet');
				setUserData({ ..._post_Email_Login });
			}
		} catch (error) {
		} finally {
			web3AuthModal.closeModal();
			setLoading(false);
		}
	};
	useEffect(() => {
		web3AuthModal.MetamaskLogin = MetamaskLogin;
		web3AuthModal.handleAuthMetamask = handleMatamaskAuth;
		web3AuthModal.on('MODAL_VISIBILITY', isVisible => {
			if (isVisible) setLoading(true);
			else setLoading(false);
		});
	}, []);

	useEffect(() => {
		const wagmiCache = localStorage.getItem('wagmi.connected');
		const wagmiWallet = localStorage.getItem('wagmi.wallet');
		const parsedOpenLoginCache = getOpenLoginCache();
		const checkWalletReady = () => {
			if (
				!isConnected &&
				wagmiCache &&
				loginConnector === 'cryptoWallet'
			) {
				handleMatamaskAuth();
			}
		};
		if (
			!isConnected &&
			((wagmiCache && parsedOpenLoginCache?.idToken?.length > 0) ||
				(window.location.hash.indexOf('result') > 0 &&
					window.location.hash.indexOf('_pid') > 0 &&
					window.location.hash.indexOf('sessionId') > 0))
		) {
			handleAuth();
		}
		checkWalletReady();
	}, []);

	return (
		<Suspense
			fallback={
				<div
					style={{
						background: '#000',
						width: '100%',
						height: '100vh',
					}}></div>
			}>
			<BrowserRouter>
				{loading && <Loading />}
				<ScrollToTop />
				<Switch>
					{/* <Route path="/" exact={true} render={()=>{<FirstVisit setOpenVideo={setOpenVideo} openVideo={openVideo} />}}> */}
					{/* {
            openVideo
              ? <FirstVisit setOpenVideo={setOpenVideo} openVideo={openVideo} />
              : <NewMain />
           } */}
					{/* {
            localStorage.getItem("visit")
              ? null
              : <Route path="/welcome" exact={true} render={() => <FirstVisit setOpenVideo={setOpenVideo} openVideo={openVideo} />} />
          } */}
					{window.innerWidth <= 1200 && isMobile ? (
						<Route
							path='/'
							exact={true}
							render={() => (
								<M_newMain
									handleAuth={handleAuth}
									handleMatamaskAuth={handleMatamaskAuth}
								/>
							)}
						/>
					) : null}

					{window.innerWidth > 1200 || !isMobile ? (
						<Route
							path='/'
							exact={true}
							render={() => (
								<NewMain
									windowWidth={windowWidth}
									handleAuth={handleAuth}
									handleMatamaskAuth={handleMatamaskAuth}
								/>
							)}
						/>
					) : null}

					{/* <Route path="/" exact={true} component={NewMain} /> */}
					{window.innerWidth <= 1200 && isMobile ? (
						<Route
							path='/about'
							exact={true}
							render={() => (
								<NewMain
									windowWidth={windowWidth}
									handleAuth={handleAuth}
									handleMatamaskAuth={handleMatamaskAuth}
								/>
							)}
						/>
					) : null}
					<Route
						path='/Gallery'
						exact={true}
						render={() => (
							<Gallery
								handleAuth={handleAuth}
								windowWidth={windowWidth}
							/>
						)}
					/>
					<Route
						path='/Nftmarket'
						exact={true}
						component={Nftmarket}
					/>
					<Route
						path='/NftmarketDetail'
						exact={true}
						component={NftmarketDetail}
					/>
					<Route
						path='/Story'
						exact={true}
						render={() => (
							<Story
								handleAuth={handleAuth}
								windowWidth={windowWidth}
							/>
						)}
					/>
					<Route
						path='/Mypage'
						exact={true}
						render={() => (
							<Mypage
								handleAuth={handleAuth}
								windowWidth={windowWidth}
								handleMatamaskAuth={handleMatamaskAuth}
							/>
						)}
					/>
				</Switch>
			</BrowserRouter>
			{/* {windowWidth < 1430 && <AlertMobileMode/>} */}
		</Suspense>
	);
}

export default App;
